import { Box, useBoolean } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { SheetEyeIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';
import { getDocumentViewerPath } from '../../../components/pdf_viewer/documentViewer.utils';

const AuditSheetFileViewer = ({ 
  auditData, 
  icon, 
  chart_id=null,
  onOpen = () => {},
  onClose = () => {}
 }) => {
  const [isFileOpen, ifoState] = useBoolean(false);
  const resourceId = auditData?.id || chart_id;
  const reportChartId = chart_id || auditData?.upload_id || resourceId;
  const { attachment } = useAuditReportAttachment({
    chartId: isFileOpen ? reportChartId : null,
  });
  const handleOpen = () => {
    onOpen();
    ifoState.on();
  }

  return (
    <React.Fragment>
      {icon ? 
      <Box onClick={handleOpen}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}> {icon}</Box> : <SheetEyeIcon
        onClick={handleOpen}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}
      />}
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditData?.file_obj}
        attachments={[
          ...(auditData?.attachments || []),
          ...(reportChartId && attachment ? [attachment] : [])
        ]}
        viewerPath={getDocumentViewerPath({ chartId: resourceId })}
        chartId={auditData?.upload_id || auditData?.file_id || resourceId}
        onClose={() => {
          ifoState.off();
          onClose();
        }}
      />
    </React.Fragment>
  );
};

export default AuditSheetFileViewer;
